<template>
	<div id="app">
		<transition name="fade"
		            mode="out-in">
			<router-view></router-view>
		</transition>
	</div>
</template>

<script>
export default {
	name: 'app',
	components: {
	}
}

</script>

<style lang="scss">
body {
	margin: 0px;
	padding: 0px;
	/*background: url(assets/bg1.jpg) center !important;
		background-size: cover;*/
	// background: #1F2D3D;
	font-family: Helvetica Neue, Helvetica, PingFang SC, Hiragino Sans GB, Microsoft YaHei, SimSun, sans-serif;
	font-size: 14px;
	-webkit-font-smoothing: antialiased;
    background-color: #ffda8e;
}

#app {
	position: absolute;
	top: 0px;
	bottom: 0px;
	width: 100%;
}

.el-submenu [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-menu-item [class^=fa] {
	vertical-align: baseline;
	margin-right: 10px;
}

.el-message-box__headerbtn {
	display: none;
}

.toolbar {
	background: #f2f2f2;
	padding: 10px;
	//border:1px solid #dfe6ec;
	margin: 10px 0px;
	.el-form-item {
		margin-bottom: 10px;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: all .2s ease;
}

.fade-enter,
.fade-leave-active {
	opacity: 0;
}

.rate-input.el-select .el-input {
     width: 84px !important;
     .el-input__inner {
         width: 84px  !important;
     }
}

.tax-input.el-input {
    width: 42px !important;
    .el-input__inner {
        text-align: center !important;
        width: 42px !important;
        padding-left: 8px;
        margin-right: 0;
    }
}
.el-pagination__editor {
    border: 0 !important;
}

.el-table tr.not-exist-row {
    color: rgb(121, 121, 121) !important;
}
.el-table tr.warning-row {
    color: rgb(150, 0, 0) !important;
}
.el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--month .el-input__prefix {
    left: 32px !important;
}
.el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--month .el-input__suffix {
    display: none !important;
}
.el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--month .el-input__inner {
    padding-right: 8px;
}
.el-date-editor.el-input.el-input--prefix.el-input--suffix.el-date-editor--date .el-input__prefix {
    left: 32px !important;
}
span.el-range-separator {
    padding-bottom: 4px !important;
    padding-right: 9px !important;
}
</style>


// WEBPACK FOOTER //
// App.vue?6560db60